__turbopack_context__.v({
  "className": "inter_efe2dea7-module__h70VMW__className",
  "variable": "inter_efe2dea7-module__h70VMW__variable",
});
